export default "__VITE_ASSET__530508ba__"